module.exports = __webpack_public_path__ + "media/logos/hsbc-cd7e054e.png";